<div class="p-3">
  <div class="company-info-block">
    <div class="small-name">
      <div *ngIf="!logoUri">{{ smallName }}</div>
      <div class="company-logo" *ngIf="logoUri" [ngStyle]="{ 'background-image': 'url(' + logoUri + ')' }"></div>
    </div>

    <div class="company-info header">
      <div class="company-name">{{ fullName }}</div>
      <div class="company-description">
        {{
          company && company?.identifierQualifier
            ? (company.identifier | identifier) + " (" + ("IDENTIFIER_QUALIFIER." + company.identifierQualifier | translate) + ")"
            : user.email
        }}
      </div>
    </div>

    <div>
      <button (click)="toggleOpen()" class="btn-toggle" type="button">
        <icon-toggle-open-close [open]="open"></icon-toggle-open-close>
      </button>
    </div>
  </div>
  <div *ngIf="open" class="pt-3 company-list">
    <div *ngIf="companies?.length" class="company-info company-list-item">
      <div class="company-name my-companies">{{ "LABELS.MY_COMPANIES" | translate }}:</div>
    </div>

    <div
      *ngFor="let company_a of companies"
      class="company-info company-list-item cursor-pointer py-1"
      (click)="selectCompany($event, company_a)"
    >
      <div class="company-name">
        {{ !!company_a?.businessName ? company_a.businessName : ("LABELS.EMPTY_IOR" | translate) }}
      </div>
      <div class="company-description" *ngIf="!!company_a.identifier && !!company_a.identifierQualifier">
        {{ company_a.identifier + " (" + ("IDENTIFIER_QUALIFIER." + company_a.identifierQualifier | translate) + ")" }}
      </div>
      <div class="company-hint" *ngIf="!company_a?.businessName">
        {{ "COMPLETE_IOR_PROFILE" | translate }}
      </div>
    </div>

    <div
      class="company-list-item d-flex justify-content-between align-content-center align-items-center cursor-pointer"
      [ngClass]="{ 'pt-3': companies?.length }"
      [routerLink]="['/companies', 'account-settings', 'create']"
    >
      <div>
        {{ "MENU.ADD_NEW_COMPANY" | translate }}
      </div>
      <div class="circle">
        <span class="icon-ic icon-ic_plus"></span>
      </div>
    </div>
  </div>
</div>
